import Radio from "../../../general/input/radio/Radio";
import RadioGroup from "../../../general/input/radio/RadioGroup";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useSession from "../../../../services/state/session/useSession";

const CartDeliveryMethod = () => {

    const session = useSession();
    const selected = useCheckoutStore(state => state.input?.deliveryMethod);
    const setDeliveryMethod = useCheckoutStore(state => state.setDeliveryMethod);

    const onRadioClick = (deliveryVia) => () => setDeliveryMethod(session, deliveryVia);

    return (
        <div className="cart-sub-section">
            <p className="cart-h">Delivery Via</p>
            <RadioGroup>
                <Radio
                    title="Delivery"
                    isSelected={'D' === selected}
                    onSelected={onRadioClick('D')}
                />
                <Radio
                    title="Collection"
                    isSelected={'P' === selected}
                    onSelected={onRadioClick('P')}
                />
            </RadioGroup>
            {selected === 'P' &&
                <p className="cart-warning">Your order will need to be picked from the Wick Depot</p>
            }
        </div>
    )

}

export default CartDeliveryMethod;
